<template>
  <div class="flex flex-col justify-center items-center border-gray-100 shadow-md border-2 hover:border-pink-700" >
    <div class="p-2">
      <img class="rounded-full shadow-lg transform hover:scale-105 transition transition-all duration-500" :src="achiever.image" :alt="achiever.name">
    </div>
    <div class="px-2 py-3 text-center">
      <h3 class="text-lg font-medium text-gray-800">{{achiever.name}}</h3>
      <span class="font-medium text-gray-600">{{ achiever.score }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AchieverComponent",
  props:{
    achiever:Object
  }
}
</script>

<style scoped>

</style>